import {useEffect, useState} from 'react';

const useJivoWidget = () => {
  const [scrollPosition, setScrollPosition] = useState<number>(window.scrollY);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const updateJivoVisibility = () => {
      const footer = document.querySelector('.footer');
      const upwardButton = document.querySelector('.upward-button');
      const jivoIcons = [
        document.getElementById('jivo_custom_widget'),
        document.getElementById('jivo_custom_widget2'),
        document.getElementById('jivo_custom_widget3'),
        document.getElementById('jivo_custom_widget4'),
      ].filter((icon): icon is HTMLElement => icon !== null);

      if (jivoIcons.length === 4) {
        // Обработка видимости относительно футера
        if (!footer || window.getComputedStyle(footer).display === 'none') {
          jivoIcons.forEach(icon => {
            icon.style.visibility = 'visible';
            icon.style.opacity = '1';
          });
        } else {
          const footerTop = footer.getBoundingClientRect().top;
          const windowHeight = window.innerHeight;

          if (footerTop <= windowHeight) {
            jivoIcons.forEach(icon => {
              icon.style.visibility = 'hidden';
              icon.style.opacity = '0';
            });
          } else {
            jivoIcons.forEach(icon => {
              icon.style.visibility = 'visible';
              icon.style.opacity = '1';
            });
          }
        }

        // Обработка положения bottom относительно upwardButton
        if (upwardButton) {
          const isUpwardHidden = window.getComputedStyle(upwardButton).display === 'none';
          if (isUpwardHidden) {
            jivoIcons[0].style.bottom = '190px'; // jivo_custom_widget
            jivoIcons[1].style.bottom = '150px'; // jivo_custom_widget2
            jivoIcons[2].style.bottom = '50px'; // jivo_custom_widget3
            jivoIcons[3].style.bottom = '110px'; // jivo_custom_widget4
          } else {
            // Значения, когда кнопка видна
            jivoIcons[0].style.bottom = '260px'; // jivo_custom_widget
            jivoIcons[1].style.bottom = '220px'; // jivo_custom_widget2
            jivoIcons[2].style.bottom = '120px'; // jivo_custom_widget3
            jivoIcons[3].style.bottom = '180px'; // jivo_custom_widget4
          }
        }
      }
    };

    const waitForJivo = setInterval(() => {
      const jivoIcons = [
        document.getElementById('jivo_custom_widget'),
        document.getElementById('jivo_custom_widget2'),
        document.getElementById('jivo_custom_widget3'),
        document.getElementById('jivo_custom_widget4'),
      ].filter((icon): icon is HTMLElement => icon !== null);

      if (jivoIcons.length === 4) {
        clearInterval(waitForJivo);
        updateJivoVisibility();

        const observer = new MutationObserver(() => {
          updateJivoVisibility();
        });

        jivoIcons.forEach(icon => {
          observer.observe(icon, { attributes: true, attributeFilter: ['style'] });
        });

        return () => {
          observer.disconnect();
        };
      }
    }, 100);

    updateJivoVisibility();

    return () => {
      clearInterval(waitForJivo);
    };
  }, [scrollPosition]);
};

export default useJivoWidget;